import { render, staticRenderFns } from "./VerisureAlarm.vue?vue&type=template&id=5cd913f2&scoped=true"
import script from "./VerisureAlarm.vue?vue&type=script&lang=js"
export * from "./VerisureAlarm.vue?vue&type=script&lang=js"
import style0 from "./VerisureAlarm.vue?vue&type=style&index=0&id=5cd913f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd913f2",
  null
  
)

export default component.exports